import { Posts } from '@/models/posts';
import { Updates } from '@/models/updates';
import { Violations } from '@/models/violations';
import getRoute from '@/utils/getRoute';

export interface UpdatesConfig<T> {
  queryKeys: {
    list: string[];
    detail: (postId: number) => (string | number)[];
  };
  getNavigationRoute: (context: Updates.Dialog) => string;
  linkText: string;
  getLastUpdatedAt: (violation: T) => string | null;
  getOriginalRescrape: (violation: T) => string | null;
  getRescrapeRequests: (violation: T) => Updates.Rescrape[];
  getUpdates: (violation: T) => { isDeleted?: boolean }[];
}

export const violationsConfig: UpdatesConfig<
  Violations.Details | Violations.ViolationRecord
> = {
  queryKeys: {
    list: ['violations'],
    detail: (postId) => ['violation', postId]
  },
  getNavigationRoute: (context) =>
    getRoute.evaluations.POST(context?.evaluationId, context?.postId),
  linkText: 'Open Evaluations Post',
  getLastUpdatedAt: (violation) => violation?.lastUpdatedAt ?? null,
  getOriginalRescrape: (violation) => violation?.originalPost ?? null,
  getRescrapeRequests: (violation) => violation?.rescrapeRequests ?? [],
  getUpdates: (violation) => violation?.updates ?? []
};

export const evaluationsConfig: UpdatesConfig<Posts.Details> = {
  queryKeys: {
    list: ['posts'],
    detail: (postId) => ['post', postId]
  },
  getNavigationRoute: (context) => getRoute.violations.DETAIL(context?.postId),
  linkText: 'Open Violations Post',
  getLastUpdatedAt: (violation) => violation?.evaluation?.lastUpdatedAt ?? null,
  getOriginalRescrape: (violation) =>
    violation?.evaluation?.originalPost ?? null,
  getRescrapeRequests: (violation) =>
    violation?.evaluation?.rescrapeRequests ?? [],
  getUpdates: (violation) => violation?.evaluation?.updates ?? []
};
